
import { REMINDAPPROVEEXPENSE_SUCCESS, REMINDAPPROVEEXPENSE_FAIL } from '../actionTypes';
const initialState = {
    user: null,
    loading: false
};

const remindApproveReducer = (state = initialState, action) => {
    switch (action.type) {
        case REMINDAPPROVEEXPENSE_SUCCESS:
            return {
                ...state,
                loading: true,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case REMINDAPPROVEEXPENSE_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default remindApproveReducer;
